import axios from 'axios';

export const signatureRequestService = {
    getSignatureRequestService: (token) =>
        axios.get(`/signature-request/public/review`, { headers: { 'signature-token': token } }),

    presignSignatureService: (token, params) =>
        axios.post(`/signature-request/public/presign`, params, { headers: { 'signature-token': token } }),

    uploadSignatureService: (uploadUrl, file, requiredHeaders) => {
        const bareAxios = axios.create();
        return bareAxios.put(uploadUrl, file, { headers: requiredHeaders });
    },

    signSignatureRequestService: (token, params) =>
        axios.post(`/signature-request/public/sign`, params, { headers: { 'signature-token': token } }),
};
